export default __webpack_public_path__ + "static/media/front-cover.adba22c4.png";